const BaseURL = process.env.REACT_APP_API_URL;

class AppURL {
    static BaseURL = "https://adwapi.prefacetechnology.com.np/";
    static ApplicationURL = `${this.BaseURL}khanepani/app/`;
    static FrontOfficeURL = `${this.BaseURL}khanepani/front/office/`;
    static AccountURL = `${this.BaseURL}khanepani/account/`;
    static InventoryURL = `${this.BaseURL}khanepani/inventory/`;
    static PayrollURL = `${this.BaseURL}khanepani/payroll/`;
    static TapsURL = `${this.BaseURL}khanepani/taps/`;
}

export default AppURL;
